import { SearchType } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { SEARCH_HINTS } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import { DeviceListingFieldName } from 'src/app/pages/equipment/devices/components/devices.models';
import { DeviceHistoryFieldName } from '../services/history-api.types';

export const HISTORY_LOG_SEARCH_TYPES: SearchType[] = [
  {
    text: TranslateRegistry.get.SEARCH.TYPE.COMM_DEVICE_ID,
    value: 1,
    types: [DeviceListingFieldName.CommDeviceId],
    hintText: SEARCH_HINTS.CommDeviceId
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.INVENTORY_ID,
    value: 5,
    types: [DeviceHistoryFieldName.MeterNumber],
    hintText: SEARCH_HINTS.InventoryId
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.MODEL_NAME,
    value: 2,
    types: [DeviceListingFieldName.ModelName],
    hintText: SEARCH_HINTS.ModelName
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.SERIAL_NUMBER,
    value: 3,
    types: [DeviceListingFieldName.SerialNumber],
    hintText: SEARCH_HINTS.SerialNumber
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.USER_NAME,
    value: 4,
    types: [DeviceHistoryFieldName.UpdatedBy],
    hintText: SEARCH_HINTS.UserName
  }
];

export const HISTORY_LOG_DEFAULT_SEARCH_TYPE: SearchType = HISTORY_LOG_SEARCH_TYPES[3];
